import React from 'react';
import { TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface MonacoYamlEditorProps {
  value?: string;
  onChange?: (value: string | undefined) => void;
  height?: string | number;
  readOnly?: boolean;
  placeholder?: string;
}

/**
 * 简化版 YAML 编辑器
 * 使用 TextField 替代 Monaco Editor，减少打包体积
 */
const MonacoYamlEditor: React.FC<MonacoYamlEditorProps> = ({
  value = '',
  onChange,
  height = 320,
  readOnly = false,
  placeholder = '# 在此输入 YAML 配置'
}) => {
  const theme = useTheme();

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(event.target.value);
  };

  return (
    <TextField
      fullWidth
      multiline
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={readOnly}
      sx={{
        '& .MuiInputBase-root': {
          fontFamily: 'Monaco, Menlo, "Courier New", monospace',
          fontSize: 14,
          lineHeight: 1.6,
          padding: 2,
          backgroundColor: theme.palette.mode === 'dark' ? '#1e1e1e' : '#f5f5f5',
        },
        '& .MuiInputBase-input': {
          height: typeof height === 'number' ? `${height}px !important` : height,
          overflow: 'auto !important',
          whiteSpace: 'pre',
          wordWrap: 'normal',
          overflowWrap: 'normal',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.mode === 'dark' 
            ? 'rgba(255, 255, 255, 0.12)' 
            : 'rgba(0, 0, 0, 0.12)',
        },
      }}
    />
  );
};

export default MonacoYamlEditor; 